module.exports = __webpack_public_path__ + "static/media/4.3fea3876.JPG";